import { Component, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import {GlobalStoreService} from "../../shared/_services/global-store.service";

declare var $: any;

@Component({
  selector: 'app-horizontal-navigation',
  templateUrl: './horizontal-navigation.component.html'
})
export class HorizontalNavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};
  public showSearch = false;
  public isCollapsed = false;
  public showMobileMenu = false;

  public selectedLanguage: any = {
    language: 'Italian',
    code: 'it',
    type: 'IT',
    icon: 'it'
  }

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'us'
    },
    {
      language: 'Español',
      code: 'es',
      icon: 'es'
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'fr'
    },
    {
      language: 'German',
      code: 'de',
      icon: 'de'
    },
    {
      language: 'Italian',
      code: 'it',
      icon: 'it'
    }
  ]
  environment = environment;


  constructor(private modalService: NgbModal, private translate: TranslateService, public store: GlobalStoreService) {
    translate.setDefaultLang('it');
    /*store.$numNotifiche.subscribe(data => this.notifiche = data)*/
  }

  changeLanguage(lang: any) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;
  }
  ngAfterViewInit() { }

}
